// extracted by mini-css-extract-plugin
export default {"sizesContent":"SizesContent_sizesContent__WejdS","sizesContentItem":"SizesContent_sizesContentItem__wPOd9","sizesContentForModal":"SizesContent_sizesContentForModal__v4pbf"};